import Card from "./Card";
import styles from "./BlogLayout.module.css";

function BlogGrid({ posts }) {
  return posts.edges.length ? (
    <div className={styles.grid}>
      {posts.edges.map((post, i) => (
        <div key={post.id} className={styles.gridItem}>
          <Card {...post} i={i} />
        </div>
      ))}
    </div>
  ) : (
    <h4 className="text-center">No posts yet!</h4>
  );
}

export default BlogGrid;
